import React, { useEffect } from 'react';
// 共通関数
import Util from './Util';
// 日付と時刻をパース・検証・操作・表示する最小のモダンブラウザ向けライブラリ
import dayjs from 'dayjs';

const ItemList = (props) => {
	const { items, dev } = props;
	if (dev) console.log("★ItemList起動");

	// // 画像などすべての要素を読み込んだ後のイベント
	// window.addEventListener("load", function (event) {
	// 	Util.setHeightBox();
	// 	if (dev) console.log("setHeight");
	// });

	// 商品リストの出力処理
	const roop = () => {
		if (items.length === 0) return;

		// 商品毎の配列
		let dlDayHash = [];
		for (let i in items) {
			// アイコン配列
			if (Array.isArray(items[i].icon)) {
				items[i].icons = [];
				for (let j in items[i].icon) {
					items[i].icons.push(<span className="ico" key={"ico" + i + "-" + j}>{items[i].icon[j]}</span>);
				}
			}
			// キーの作成
			let key = dayjs(new Date(items[i].release)).format('YYYY-MM-DD');

			// 商品情報の登録（日毎のキーに配列として商品を登録）
			if (!(key in dlDayHash)) dlDayHash[key] = [];
			dlDayHash[key].push(items[i]);
		}

		// 日付順にソート
		let keys = Object.keys(dlDayHash);
		keys.sort();

		// ▼日付ごとの処理
		let dl = [];
		for (let key of keys) {
			// 曜日の用意
			const d = new Date(key);
			const day = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"][d.getDay()];

			// ▼アイテムごとの処理
			let tmp = [];
			for (const elem of dlDayHash[key]) {
				tmp.push(
					<li key={elem.id} className="sso-ItemList5__Item">
						<a href={elem.link_url}>
							<img src={elem.image_url + "?w=400,h=400"} width="208" height="208" alt={elem.caption} />
							<div className="js-fix">
								<div className="sso-ItemList5__ItemCaption">
									<div className="sso-CmsBrandModule__Heading3">
										{elem.brandname}
									</div>
									<div className="sso-MultiLineEllipsis2">
										{elem.caption}
									</div>
								</div>

								<div className="sso-ItemList5__ItemPrice">
									<span className="sso-Price">
										{elem.price}
									</span>
								</div>
								<div className="labelbox">
									{elem.icons}
								</div>
							</div>

							<div className="sso-CmsBrandModule__InlineLink">
								<span className="sso-InlineLink">くわしくはこちら</span>
							</div>
						</a>
					</li >
				);
			}
			// タイトル
			dl.push(
				<div className="sso-ItemList5" key={"itemlist" + key} id={"d" + key} name={"d" + key}>
					<div className="message"></div>
					<div className="releasedate">
						<h2 className="ttl">
							<span className="month">{d.getMonth() + 1}</span>
							<span className="slash"></span>
							<span className="day">{d.getDate()}</span>
							<span className="sub">{day}</span>
						</h2>
					</div>
					<ul className="sso-ItemList5__List">
						{tmp}
					</ul>
				</div>
			);
		}

		return dl;
	};


	// 初回レンダリング後と、useした値の更新後に自動で実行
	useEffect(() => {
		// if (dev) console.log("useEffect");
		// ATTENTION
		// document.querySelector(".bg01").innerHTML += "useEffect<br>";

		// JSON読み込み前は処理しない
		if (items.length > 0) {
			if (dev) console.log("▼画像読み込みイベント");
			// 全画像読み込み後に要素の高さを揃える
			const imgs = document.querySelectorAll('.sso-ItemList5__List img');
			Util.setLoadAllCallback(imgs, function () {
				Util.setHeightBox();
				if (dev) console.log("setLoadAllCallbackのコールバック");
				// ATTENTION
				// document.querySelector(".message").innerHTML += "setHeightBox実行<br>";
			});
		}

	});

	// JSX
	return (
		<div className="bg02">
			<div className='conts-cosmeItemList areainner'>
				{
					roop()
				}
			</div>
		</div>
	)
}


export default ItemList;

